import react, { useEffect, useRef } from 'react';
import { Graphics } from 'pixi.js';
import { Container } from '@pixi/react';

import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../../../hooks';
import { isMobile } from '../../../../../../helpers';
import { soundService, SoundTypes } from '../../../../../../services/soundService';

export const JackPotSceneItemGraphics: React.FC<any> = observer(({
  index,
  width,
  height,
  isOpened,
  isAllowDoJackpotAction,
  jackPotSceneItemBoxRef,
  setIsAllowDoJackpotAction
}) => {
  const graphicRef: any = useRef(null);
  const { jackpotStore } = useStore();

  const handleSelectCard = () => {
    if (isAllowDoJackpotAction && !isOpened) {
      soundService.play(SoundTypes.JackpotSuitAppearance);
      setIsAllowDoJackpotAction(false);
      jackpotStore.invokeOpenJackpotSceneItem(index);
    };
  };

  const handlePointerOver = () => {
    if (!isOpened) {
      jackPotSceneItemBoxRef.current.children[0].play('hover');
    };
  };

  const handlePointerLeave = () => {
    if (!isOpened) {
      jackPotSceneItemBoxRef.current.children[0].stop();
    };
  };

  useEffect(() => {
    const graphics = new Graphics();
    graphics.clear();
    graphics.beginFill('black');
    graphics.alpha = 0;
    graphics.drawRect(0, 0, width, height);
    graphics.pivot.set(70, 70);
    graphicRef.current.addChild(graphics);
  }, [width, height]);

  return (
    <Container
      key={index}
      value={index}
      ref={graphicRef}
      cursor='pointer'
      {...({ interactive: true } as any)}
      name='jackPotSceneItemGraphicsContainer'
      pointerup={handleSelectCard}
      pointerover={isMobile() ? () => { } : handlePointerOver}
      pointerout={isMobile() ? () => { } : handlePointerLeave}
    />
  );
});
